module.exports = __webpack_public_path__ + "static/img/call-pass.f8e4f3d9.png";